import { MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const WhatsAppFloat = () => {
  const { wa, lang } = useApp();
  return (
    <a
      data-testid="whatsapp-float-button"
      href={wa(lang === "id" ? "Halo Yutaka Agro, saya ingin bertanya." : "Hello Yutaka Agro, I have a question.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={24} />
    </a>
  );
};
